// USP pás (nativní `.benefitBanner` z admin Reklamních bannerů: homepage, detail,
// výpis) v době akce na dopravu (#322): položka „Doprava od 69 Kč" mluví o akční
// ceně. Text přepisuje šablona jen v okně akce (`shippingPromo()`), takže se
// sama rozsvítí i zhasne a admin se nemění (Tomáš 2026-10-07: „chci, aby se vše
// přepnulo automaticky"). Položka se pozná podle titulku z adminu
// (`L.shipTitleRe`); ostatní položky ani shop bez akce se nemění.
import { shippingPromo } from './shippingModel.js';
import { money } from './money.js';
import L from '../locale/cs/benefitPromo.js';

export function initBenefitPromo(root = document, promo = shippingPromo()) {
  if (!promo) return;
  root.querySelectorAll('.benefitBanner__title').forEach(function (title) {
    if (title.dataset.bsPromo || !L.shipTitleRe.test(title.textContent || '')) return;
    const item = title.closest('.benefitBanner__item') || title.parentElement;
    const label = L.promoTitle(money(promo.price));
    title.textContent = label;
    title.dataset.bsPromo = promo.id;
    const data = item && item.querySelector('.benefitBanner__data');
    if (data) data.textContent = L.promoText(promo.carrier, promo.maxKg, promo.untilLabel);
    const img = item && item.querySelector('.benefitBanner__img');
    if (img) img.alt = label;
  });
}
